var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 411.6,
    height: 510,
    viewBox: "0 0 411.6 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1410",
    x: 0,
    y: 0,
    width: 411.6,
    height: 510,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1410-2",
    "data-name": "Path 1410",
    d: "M199.8,134.182c24.272,0,43.733-20.127,43.733-44.727a43.291,43.291,0,0,0-6.341-23.035L199.8,0,162.408,66.42a43.29,43.29,0,0,0-6.341,23.035C156.067,114.055,175.747,134.182,199.8,134.182ZM300.387,357.595l-23.4-23.929-23.616,23.929c-28.427,29.073-78.283,29.3-106.928,0l-23.4-23.929L99.213,357.595A74.239,74.239,0,0,1,3,366.54v103.1C3,481.936,12.84,492,24.867,492H374.733c12.027,0,21.867-10.064,21.867-22.364V366.54a74.239,74.239,0,0,1-96.213-8.945ZM331,201.273H221.667V156.545H177.933v44.727H68.6C32.3,201.273,3,231.24,3,268.364V302.8c0,24.153,19.243,43.833,42.859,43.833a41.5,41.5,0,0,0,30.176-12.747l46.795-47.634,46.576,47.634c16.181,16.549,44.389,16.549,60.571,0l46.795-47.634,46.576,47.634a41.863,41.863,0,0,0,30.176,12.747c23.616,0,42.859-19.68,42.859-43.833v-34.44C396.6,231.24,367.3,201.273,331,201.273Z",
    transform: "translate(6 6)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.b687041087a37da4adf05a060ec50d35.svg";
export { ForwardRef as ReactComponent };